import { useEffect, useState } from 'react';

// project imports
import { Config } from 'utils/envConfig';
import { findKeyByValue, isValidJson } from 'utils';

// types
type UseTenantReturningType = {
  tenant: string | null;
  realm: string | null;
};

// ==============================|| HOOKS ||============================== //

const useTenant = (): UseTenantReturningType => {
  const [realm, setRealm] = useState<string | null>(null);
  const [tenant, setTenant] = useState<string | null>(null);

  useEffect(() => {
    const newTenant =
      document.location.pathname.split('/').find((item) => !!item.length) || '';

    const allowedTenants = isValidJson(Config.allowedTenants)
      ? JSON.parse(Config.allowedTenants)
      : {};

    const allowedTenant: string | null = findKeyByValue(
      allowedTenants,
      newTenant
    );

    if (allowedTenant) {
      setRealm(allowedTenant);
      setTenant(newTenant);
    }
  }, []);

  return { tenant, realm };
};

export default useTenant;
